import { Modal, Popover, PopoverProps } from 'antd'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import style from './UpgradeAlertModal.module.less'

import { commonUtils } from '@/helpers/commonUtils'
import { useState } from 'react'
import { userService } from '@/services/userService'
import { routerService } from '@/services/routerService'

export interface UpgradeAlertModalProps {
  onClose: () => void
}

export const UpgradeAlertModal = observer((props: UpgradeAlertModalProps) => {
  const { onClose } = props

  const [isHover, setIsHover] = useState(false)

  return (
    <Modal
      getContainer={false}
      maskClosable={false}
      centered
      open={true}
      wrapClassName={classNames(style.upgradeAlertModal)}
      footer={false}
      //   closable={false}
      keyboard={false}
      width='530px'
      onCancel={() => {
        onClose()
      }}
    >
      <div className={style.content}>
        <img
          className={classNames(style.top)}
          src={commonUtils.getStaticFile('upgrade_alert_top.png')}
        />

        <div className={classNames(style.info)}>
          <div className={classNames(style.title)}>
            <img
              className={classNames(style.icon)}
              src={commonUtils.getStaticFile('upgrade_alert_func.png')}
            />
            功能升级
          </div>
          <div className={classNames(style.textBox)}>
            <p className={classNames(style.text)}>
              1、全新接入高阶翻译引擎 DeepL，翻译更精准！特别是在论文等学术翻译场景下，效果尤其出众
            </p>

            <p className={classNames(style.text)} style={{ marginTop: '12px' }}>
              2、特别为学生等有文献翻译需求的用户开发了「 PDF
              翻译」功能，无论是公式图表类PDF还是扫描件，都能又快又准地帮您搞定
            </p>

            <div
              className={classNames(style.pdfBtn)}
              onClick={() => {
                routerService.openNewTab('pdf_pro')
              }}
              onMouseEnter={() => {
                setIsHover(true)
              }}
              onMouseLeave={() => {
                setIsHover(false)
              }}
            >
              快去看看
              <img
                className={classNames(style.arrow)}
                src={
                  isHover
                    ? commonUtils.getStaticFile('upgrade_alert_arrow_hover.png')
                    : commonUtils.getStaticFile('upgrade_alert_arrow.png')
                }
              />
            </div>
          </div>

          <div className={classNames(style.title)} style={{ marginTop: '21px' }}>
            <img
              className={classNames(style.icon)}
              src={commonUtils.getStaticFile('upgrade_alert_price.png')}
            />
            价格调整
          </div>
          <div className={classNames(style.textBox)}>
            <p className={classNames(style.text)}>
              为了能保持持续的迭代优化，为您提供更优质的服务体验，我们对会员价格进行了适度调整。最新价格可参考定价页面及付费弹窗
            </p>
          </div>

          <div className={classNames(style.textBox, style.bgTransparent)}>
            <p className={classNames(style.text)}>
              感谢大家一直以来对我们的认可和支持。我们会持续努力，为大家带来更多有用好用的功能和体验
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
})
